// React
import ProtoTypes from 'prop-types';

// Material UI Components
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';

// Custom UI Components
import { BaseBlockTitle, BaseBlockSubtitle } from './ui/Typography/Title';
import { CustomDivider } from './ui/Divider/CustomDivider';


function BaseBlock(props) {
    const { blockTheme } = props;
    const isLight = blockTheme === 'light';
    const backgroundColor = isLight ? 'customLight.main' : 'primary.dark';

    return (
        <Box
            sx={{
                bgcolor: backgroundColor,
                pb: 12,
            }}
            minHeight="100vh"
            display="flex"
            alignItems="center"
            justifyContent="center"
        >
            <Container
                maxWidth="xl"
            >
                <Box
                    sx={{
                        mt: 6,
                        mb: 6,
                    }}
                >
                    <BaseBlockTitle
                        value={props.blockTitle}
                        fontTheme={blockTheme}
                    >
                    </BaseBlockTitle>
                    <BaseBlockSubtitle
                        value={props.blockSubtitle}
                        fontTheme={blockTheme}
                    >
                    </BaseBlockSubtitle>
                </Box>
                <CustomDivider
                    theme={blockTheme}
                >
                </CustomDivider>

                {props.blockContent}
            </Container>
        </Box>
    );
};

BaseBlock.propTypes = {
    blockTitle: ProtoTypes.string.isRequired,
    blockSubtitle: ProtoTypes.string.isRequired,
    blockContent: ProtoTypes.element.isRequired,
    blockTheme: ProtoTypes.string,
};

BaseBlock.defaultProps = {
    blockTheme: 'light',
};

export default BaseBlock;